import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = ({isDarkMode}) => {
    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4" style={{ color: isDarkMode ? '#f8f9fa' : '#333' }}>Terms of Service</h1>
            <p style={{ color: isDarkMode ? '#f8f9fa' : '#333' }}>
                Description for the Scholarship Platform:

                "Welcome to our Scholarship Platform, your gateway to a world of educational opportunities and financial support. Our platform is designed to connect students with a diverse range of scholarships tailored to their individual needs and ambitions.

                Whether you're a high school student planning your path to higher education, an undergraduate seeking financial assistance, or a graduate student pursuing advanced studies, our platform offers a comprehensive database of scholarship opportunities to explore.


            </p>
            <p style={{ color: isDarkMode ? '#f8f9fa' : '#333' }}>
                With our user-friendly interface, you can easily search for scholarships based on criteria such as academic achievements, field of study, extracurricular activities, and demographic background. We understand that each student is unique, which is why we strive to provide a wide array of scholarship options to accommodate diverse interests and circumstances.

                Beyond financial support, our platform also offers valuable resources to help students navigate the scholarship application process. From tips on writing compelling essays to guidance on securing recommendation letters, we're here to support you every step of the way.

                At our Scholarship Platform, we believe that education should be accessible to all, regardless of financial barriers. Join us today and embark on your journey to academic success!"
            </p>
            <p>
                <Link to="/" className="btn btn" style={{ backgroundColor: isDarkMode ? '#f8f9fa' : '#333',color: isDarkMode ? '#333' : '#f8f9fa' }}>Back to Home</Link>
            </p>
        </div>
    );
};

export default TermsPage;
